export default __webpack_public_path__ + "static/media/blob_bottom.aec0ec4f.svg";